import { useEffect, useState } from 'react';
import AnimatedWrapper from '../components/AnimatedWrapper';
import { useNavigate } from 'react-router-dom';
import { motion } from "framer-motion";
import amplitude from '../utils/amplitude';


export default function Page11() {
  const [progress, setProgress] = useState(0);
  const navigate = useNavigate()
 useEffect(() => {
      if(process.env.NODE_ENV === "production"){
            amplitude.track('Quiz Step Open', {
          step_number: 11,
        });
          }
  // Прогресс-анимация
  let start = 0;
  const target = 56;
  const duration = 3000;
  const stepTime = 30;
  const increment = 100 / (duration / stepTime);

  const timer = setInterval(() => {
    start += increment;
    if (start >= target) {
      start = target;
      clearInterval(timer);
    }
    setProgress(Math.floor(start));
  }, stepTime);


  // Редирект через 9 секунд
  const redirectTimeout = setTimeout(() => {
    if(process.env.NODE_ENV === "production"){
      amplitude.track('Quiz Step Complete', {
        step_number: 11, 
        answers: ""
      });

    }
    navigate('/quiz12'); // замените на нужный путь
  }, 9000);

  return () => {
    clearInterval(timer);
    clearTimeout(redirectTimeout);
  };
}, []);
  return (
    <AnimatedWrapper>
      <div className="my-4 relative w-48 h-48 md:w-72 md:h-72 mx-auto flex items-center justify-center">
        {/* SVG-прогресс */}
        <div className="absolute inset-0 flex items-center justify-center">
          <svg className="w-full h-full rotate-[-90deg]" viewBox="0 0 100 100">
            <circle
              cx="50"
              cy="50"
              r="45"
              stroke="#f9a8d4"
              strokeWidth="10"
              fill="none"
              opacity="0.3"
            />
            <circle
              cx="50"
              cy="50"
              r="45"
              stroke="#FC5EB2"
              strokeWidth="10"
              strokeLinecap="round"
              fill="none"
              strokeDasharray="282.6"
              strokeDashoffset={282.6 - (progress / 100) * 282.6}
              style={{
                transition: 'stroke-dashoffset 0.03s linear',
              }}
            />
          </svg>
        </div>

        {/* Проценты */}
        <div className="absolute text-3xl font-bold">
          {progress}%
        </div>
      </div>

      <motion.div
        initial={{ opacity: 0}}
        animate={{ opacity: 1}}
        transition={{ delay: 1.7 , duration: 0.5}} 
        className="flex flex-col items-center mx-auto">
        <h1 className='font-semibold text-4xl text-gray-500 mb-1'>-56%</h1>
        <p className="text-xl text-gray-500 text-center mx-auto max-w-xs leading-snug">
        money spent on cosmetics
      </p>
      </motion.div>
        <div className="relative flex w-full h-72">

        {[...Array(5)].map((_, i) => (
          <motion.img
            key={i}
            src="/coin.svg"
            alt="coin"
            className="w-32 h-32 absolute"
            initial={{ y: -3, opacity: 0 }}
            animate={{ y: 40, opacity: 1 }}
            transition={{
              delay: 3.2 + i * 0.3,
              duration: 1.5,
              ease: 'easeOut'
            }}
            style={{
              left: i % 2 === 0 ? `8%` : `10%`, // чётные — правее, нечётные — левее
              bottom: `${40 + i * 7}%`,
            }}
          />
        ))}
        <motion.img
            src="/coin.svg"
            alt="coin"
            className="w-32 h-32 absolute"
            initial={{ y: -100, opacity: 0 }}
            animate={{ y: 40, opacity: 1 }}
            transition={{
              delay: 2.5,
              duration: 1.5,
              ease: 'easeOut'
            }}
            style={{
              top: `32%`,
            }}
          />

        {[...Array(3)].map((_, i) => (
          <motion.img
            key={i}
            src="/coin.svg"
            alt="coin"
            className="w-32 h-32 absolute"
            initial={{ y: -20, opacity: 0 }}
            animate={{ y: 40, opacity: 1 }}
            transition={{
              delay: 5 + i * 0.3,
              duration: 1.5,
              ease: 'easeOut'
            }}
            style={{
              left: i % 2 === 0 ? `55%` : `57%`, // чётные — правее, нечётные — левее
              bottom: `${30 + i * 7}%`,
            }}
          />
        ))}

          <motion.div
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ delay: 5.5 }}
            className="absolute flex w-full h-5 justify-around top-[87%] text-gray-500 font-medium whitespace-nowrap"
          >
            <span>
              Without Solvi
            </span>
            <span>
              With Solvi
            </span>
            
          </motion.div>
      </div>

      <p className="text-xl px-6 font-bold text-center mx-auto max-w-xs leading-snug">
        Solvi helps you save money on cosmetics by precise personalization
      </p>

      <div className="flex-grow" />
    </AnimatedWrapper>
  );
}
